module.exports = __webpack_public_path__ + "img/yeWu.635fd33c.svg";